<div class="main-layer " cdkDragHandle>
    <mat-checkbox class="mat-checkbox-slim" [checked]="layer.visible" [value]="layer.id"
                  (change)="changeVisibility($event)"
                  [disabled]="!layer.enabled"
                  [indeterminate]="inderterminate()">
                          <span title="{{layer.name}}">{{ layer.name }}</span>
    </mat-checkbox>
</div>

<!--<div class="row no-gutters mat-card mat-elevation-z2 layer-row">-->
<!--    <div class="main-layer d-flex w-100" cdkDragHandle>-->
<!--        <div class="arrow-icon-spacing">-->
<!--            <mat-icon-->
<!--                    *ngIf="layer.customOverlayProperties || layer.layersAvailable?.length > 1 || layer.childs?.length > 1"-->
<!--                    (click)="this.expandCard(layer)">-->
<!--                {{layer.cardExpansed ? 'arrow_drop_down' : 'arrow_right'}}-->
<!--            </mat-icon>-->
<!--        </div>-->
<!--        <div class="mx-1 layer-content  d-flex align-items-center">-->
<!--            <mat-checkbox class="mat-checkbox-slim" [checked]="layer.visible" [value]="layer.id"-->
<!--                          (change)="changeVisibility($event)"-->
<!--                          [disabled]="!layer.enabled"-->
<!--                          [indeterminate]="inderterminate()">-->
<!--                        <span class="text-truncate d-flex align-items-center">-->
<!--                          <span class="layer-name" [class.highlight]="layer.owner && this.filterLayer !== ''"-->
<!--                                title="{{layer.name}}">-->
<!--                            {{ layer.name }}-->
<!--                          </span>-->
<!--                        </span>-->
<!--            </mat-checkbox>-->

<!--            <mat-icon *ngIf="layer.owner && layer.description"-->
<!--                      class="icon-description material-icons material-icons&#45;&#45;outline"-->
<!--                      matTooltip="{{layer.description}}"-->
<!--                      matTooltipClass="custom-tooltip" aria-hidden="false"-->
<!--                      aria-label="layer-info">info_outline-->
<!--            </mat-icon>-->
<!--        </div>-->
<!--        <div class="d-flex align-items-center right-icons">-->
<!--            <mat-icon *ngIf="layer.owner" id="security-icon"-->
<!--                      matTooltip="This data is stored in your browser."-->
<!--                      matTooltipPosition="above">-->
<!--                verified_user-->
<!--            </mat-icon>-->
<!--        </div>-->
<!--        <div class="d-flex align-items-center tools-container">-->
<!--            <button matIconButton [matMenuTriggerFor]="layerMenu"-->
<!--                    *ngIf="layer.owner || (layer.removable && layer.owner) ||checkEditAvailable() || layer.bbox">-->
<!--                <mat-icon>more_vert</mat-icon>-->
<!--            </button>-->
<!--            <mat-menu #layerMenu="matMenu">-->
<!--                <button mat-menu-item (click)="editLayer()"-->
<!--                        *ngIf="checkEditAvailable()">-->
<!--                    <span>Edit</span>-->
<!--                </button>-->
<!--                <button id="overlay-remove-layer-menu-option" mat-menu-item (click)="removeLayer()"-->
<!--                        *ngIf="layer.owner && (layer.removable || layer.sourceName === sources.WMS || layer.sourceName === sources.WMTS || layer.sourceName === sources.WFS)">-->
<!--                    <span>Remove</span>-->
<!--                </button>-->
<!--                <button mat-menu-item (click)="fit()"-->
<!--                        [disabled]="!layer.visible"-->
<!--                        *ngIf="layer.bbox">-->
<!--                    <span>{{ layer.owner ? 'Highlight on map' : 'Show Coverage'}}</span>-->
<!--                </button>-->
<!--                <button mat-menu-item (click)="retrieveDamageAssessment()"-->
<!--                        *ngIf="checkDamageAssessmentAvailable()">-->
<!--                    <span>Retrieve damage assessment</span>-->
<!--                </button>-->
<!--            </mat-menu>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div *ngIf="layer.layersAvailable?.length > 1 && layer.cardExpansed"-->
<!--         class="child-layers">-->
<!--        <div *ngFor="let childLayer of layer.layersAvailable" class="child-layer d-flex">-->
<!--            <div class="mx-1 layer-content d-flex align-items-center">-->
<!--                <mat-checkbox [checked]="layer.visible && childLayer.visible"-->
<!--                              (change)="changeChildVisibility($event, childLayer)"-->
<!--                              [value]="layer.id">-->
<!--                                                    <span class="layer-name text-truncate"-->
<!--                                                          title="{{childLayer.name}}">{{ childLayer.name }}</span>-->
<!--                </mat-checkbox>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div *ngIf="layer.childs?.length > 1 && layer.cardExpansed"-->
<!--         class="child-layers">-->
<!--        <div *ngFor="let childLayer of layer.childs" class="child-layer d-flex">-->
<!--            <div class="mx-1 layer-content d-flex align-items-center">-->
<!--                <mat-checkbox [checked]="layer.visible && childLayer.visible"-->
<!--                              (change)="changeChildVisibility($event, childLayer)"-->
<!--                              [value]="layer.id">-->
<!--                                                    <span class="layer-name text-truncate"-->
<!--                                                          title="{{childLayer.name}}">{{ childLayer.name }}</span>-->
<!--                </mat-checkbox>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="container" *ngIf="layer.source?.features && layer.cardExpansed">-->
<!--        <ng-container *ngFor="let feature of layer.source.features.features">-->
<!--            <div class=" no-gutters child-features ">-->
<!--                <div class="feature-icon" *ngIf="layer.customOverlayProperties.iconSrc">-->
<!--                    <img src="{{layer.customOverlayProperties.iconSrc}}" alt="icon">-->
<!--                </div>-->
<!--                <div class="feature-content">-->
<!--                                <span class="primary-field text-truncate"-->
<!--                                      [class.highlight]="this.filterField === layer.customOverlayProperties.primaryField">-->
<!--                                    {{feature.properties[layer.customOverlayProperties.primaryField]}}</span>-->
<!--                    <span class="secondary-field text-secondary text-truncate"-->
<!--                          [class.highlight]="this.filterField === layer.customOverlayProperties.secondaryField">-->
<!--                                    {{feature.properties[layer.customOverlayProperties.secondaryField]}}</span>-->
<!--                </div>-->
<!--                <div class="feature-button ">-->
<!--                    <button matIconButton (click)="fitFeature(feature)">-->
<!--                        <mat-icon>send</mat-icon>-->
<!--                    </button>-->
<!--                </div>-->

<!--            </div>-->
<!--            <mat-divider></mat-divider>-->
<!--        </ng-container>-->

<!--    </div>-->

<!--</div>-->
